import React, { useState, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useSelector, useDispatch } from "react-redux";
import { createPaymentIntent, createUpiPaymentIntent } from "../functions/stripe";
import { Link, useHistory } from "react-router-dom";
import { Card } from "antd";
import { DollarOutlined, CheckOutlined, SwapOutlined } from "@ant-design/icons";
import Laptop from "../images/laptop.png";
import grocery from "../images/grocery.jpg";
import { createOrder, emptyUserCart } from "../functions/user";
import emailjs from 'emailjs-com';
import { toast } from "react-toastify";
import { Modal, message, Button } from 'antd';
import { useSpring, animated } from 'react-spring';
import { CreditCardOutlined, LoadingOutlined } from '@ant-design/icons'
import { Tabs } from 'antd';
import 'antd/dist/antd.css';
import './Ticker.css'
import { createAlignOrder } from "../functions/align";
import { PixelCheckoutDone, GoogleCheckoutDone } from "../functions/facebookEvent";
import { currencyFormatter, currencyFormatterWithMultiplier } from "../Utils/helper";

const { TabPane } = Tabs;

const StripeCheckout = ({ history, point, checked, coupon1, shipping, deliveryType, pickupStore, dispatchStore, storeNumber, expressShipping, specialId, shippingPrice, products, packing, currencyMultiplier, currency }) => {
  const history1 = useHistory();

  const dispatch = useDispatch();
  const { user, coupon, paymentProcessor } = useSelector((state) => ({ ...state }));

  const [loading, setLoading] = useState(false);


  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [clientSecret, setClientSecret] = useState("");
  const [upiClientSecret, setUpiClientSecret] = useState("");

  const [cartTotal, setCartTotal] = useState(0);
  const [totalAfterDiscount, setTotalAfterDiscount] = useState(0);
  const [payable, setPayable] = useState(0);

  const [date, setDate] = useState("")
  const [time, setTime] = useState("")
  const [upiValue, setUpiValie] = useState("")

  const stripe = useStripe();
  const elements = useElements();

  const [state, toggle] = useState(true)
  const { x } = useSpring({ loop: true, from: { x: 0 }, x: 1, config: { duration: 1000 } })

  function callback(key) {
    console.log(key);
  }


  useEffect(() => {    
    
    // createUpiPaymentIntent(user.token, coupon, point, checked, coupon1, shipping, deliveryType, pickupStore, dispatchStore, storeNumber, expressShipping, specialId, date, time, shippingPrice, packing ).then((res) => {
    //   console.log("create payment intent", res.data);
    //   setUpiClientSecret(res.data.clientSecret);
    //   localStorage.setItem("UpiPaymentId", res.data.clientId)

    //   // additional response received on successful payment
    // });
    createPaymentIntent(user.token, coupon, point, checked, coupon1, shipping, deliveryType, pickupStore, dispatchStore, storeNumber, expressShipping, specialId, date, time, shippingPrice, packing, currencyMultiplier, currency).then((res) => {
      console.log("create payment intent", res.data);
      setClientSecret(res.data.clientSecret);
      setCartTotal(res.data.cartTotal);
      setTotalAfterDiscount(res.data.totalAfterDiscount);
      setPayable(res.data.payable);
      localStorage.setItem("cardPaymentId", res.data.clientId)

    })
    setDate(localStorage.getItem("Date"))
    setTime(localStorage.getItem("Slot"))
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);
    setLoading(true)
    toggle(!state)
    const payload = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement),
        billing_details: {
          name: user.name,
          phone: user.PhoneNumber,
        },
      },
    });
    if (payload.error) {
      setError(`Payment failed ${payload.error.message}`);
      setProcessing(false);
      setLoading(false);

    } else {
      // here you get result after successful payment
      // create order and save in database for admin to process
      createOrder(payload, user.token, point, checked, date, time, coupon1, shipping, deliveryType, pickupStore, dispatchStore, storeNumber, expressShipping, specialId, shippingPrice, packing).then((res) => {
        if (res.data.ok) {
          // empty cart from local storage
          localStorage.removeItem("cart");
          localStorage.removeItem("Date");
          localStorage.removeItem("Slot");
          localStorage.removeItem("cardPaymentId");
          localStorage.removeItem("setPoints");
          localStorage.removeItem("setCoupon");
          localStorage.removeItem("UpiPaymentId");

          // empty cart from redux
          dispatch({
            type: "ADD_TO_CART",
            payload: [],
          });
          // reset coupon to false
          dispatch({
            type: "COUPON_APPLIED",
            payload: false,
          });
          // empty cart from database
          emptyUserCart(user.token);
          setLoading(false);

          // elements.getElement(CardElement).clear();

          // empty user cart from redux store and local storage
          console.log(JSON.stringify(payload, null, 4));
          setError(null);
          setProcessing(false);
          setSucceeded(true);
          toast.success("Order Confirmed! You can find details in User History")
          PixelCheckoutDone(products, cartTotal)
          GoogleCheckoutDone(products, cartTotal, shippingPrice, packing, specialId);


          setTimeout(history1.push('/user/history'), 2000)
          setTimeout(window.location.reload(), 2000)

        }
      });

      emailjs.sendForm('gmail', 'template_d3ybduj', e.target, 'user_1FbCneze2Ijh5xBQ1ARJQ')
        .then((result) => {
          console.log(result.text);
        }, (error) => {
          console.log(error.text);
        });
    }
  };

  const handleChange = async (e) => {
    // listen for changes in the card element
    // and display any errors as the custoemr types their card details
    setDisabled(e.empty); // disable pay button if errors
    setError(e.error ? e.error.message : ""); // show error message
  };

  const cartStyle = {
    style: {
      base: {
        color: "#32325d",
        fontFamily: "Arial, sans-serif",
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#32325d",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
  };

  const handleCross = () => {
    clearInterval(interval);
    messageDiv.removeChild(document.getElementById("timerDiv"));
    messageLabel.innerHTML = '';
  }

  var form = document.getElementById('payment-form');
  var countDownTime;
  var interval;
  var vpa = document.getElementById('vpa');
  var inputDiv = document.getElementById('upi-input');
  var messageDiv = document.getElementById('upi-message');
  var messageLabel = document.getElementById('payment-message');
  var timer1 = function () {
    var remainingTime = countDownTime - new Date().getTime();
    var minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
    document.getElementById("timer").innerHTML = "Your payment will expire in " + minutes + "m : " + String(seconds).padStart(2, '0') + "s";

    if (remainingTime < 0) {
      // Timer has expired, remove the timer element
      clearInterval(interval);
      messageDiv.removeChild(document.getElementById("timerDiv"));
      messageLabel.innerHTML = "Getting your payment status";
    };
  }

  const handeUpi = (event) => {
    event.preventDefault();
    // var submitButton = document.getElementById('submit-button');
    // var clientSecret = submitButton.dataset.secret;
    stripe.confirmUpiPayment(
      upiClientSecret,
      {
        payment_method: {
          upi: {
            vpa: upiValue,
          },
          billing_details: {
            name: user.name,
            phone: user.PhoneNumber,
          },
        }
      }
    ).then(function (result) {
      // Stop the timer and remove the timer element
      clearInterval(interval);
      messageDiv.removeChild(document.getElementById("timerDiv"));
      messageLabel.innerHTML = '';

      if (result.error) {
        document.getElementById('error-message').textContent = result.error.message;
        setLoading(false)
      } else {
        if (result.paymentIntent.status == 'succeeded') {
          toast.success('Payment successful')
           createOrder(result, user.token, point, checked, date, time, coupon1, shipping, deliveryType, pickupStore, dispatchStore, storeNumber, expressShipping, specialId, shippingPrice, packing).then((res) => {
            if (res.data.ok) {
              // empty cart from local storage
              localStorage.removeItem("cart");
              localStorage.removeItem("Date");
              localStorage.removeItem("Slot");
              localStorage.removeItem("cardPaymentId");
              localStorage.removeItem("setPoints");
              localStorage.removeItem("setCoupon");
              localStorage.removeItem("UpiPaymentId");

              // empty cart from redux
              dispatch({
                type: "ADD_TO_CART",
                payload: [],
              });
              // reset coupon to false
              dispatch({
                type: "COUPON_APPLIED",
                payload: false,
              });
              // empty cart from database
              emptyUserCart(user.token);
              setLoading(false);

              // empty user cart from redux store and local storage
              setError(null);
              setProcessing(false);
              setSucceeded(true);
              toast.success("Order Confirmed! You can find details in User History")
              PixelCheckoutDone(products, cartTotal)
              GoogleCheckoutDone(products, cartTotal, shippingPrice, packing, specialId);


              setTimeout(history1.push('/user/history'), 2000)
              setTimeout(window.location.reload(), 2000)

            }
          });
          setLoading(false)

        }
      }
    });

    // Create an HTML element for displaying timer
    var timerDiv = document.createElement("DIV");
    timerDiv.setAttribute("id", "timerDiv");
    var timerLabel = document.createElement("LABEL");
    timerLabel.setAttribute("id", "timer");
    timerDiv.append(timerLabel);
    messageDiv.append(timerDiv);

    // Display message for Payment in Progress
    // Hide the input section
    inputDiv.style.display = 'none';

    // Make the message section visible
    messageDiv.style.display = 'block';
    messageLabel.innerHTML = 'Payment in progress<br>Please authenticate the transaction on your UPI App<br>After authentication come back to this app and wait on this page<br>Please dont close page';

    // Set countdown to 5 mins
    countDownTime = Date.now() + 5 * 60 * 1000;

    dispatch({
      type: "SET_PAYMENT_ON",
      payload: true,
    });

    // Start the timer
    interval = setInterval(timer1, 1000);
    window.interval = interval
  };

  const handRemove = () => {
    clearInterval(window.interval);
    
    messageDiv.remove()
    inputDiv.remove()
    messageLabel.remove()
    // messageDiv.removeChild(document.getElementById("timerDiv"));
    // messageDiv.removeChild(document.getElementById("timerDiv"));

    // messageLabel.innerHTML = '';
    console.log('meeho');
    
  }


  return (
    <>
      {!succeeded && (
        <div>
          {coupon && totalAfterDiscount !== undefined ? (
            <p className="alert alert-success">{`Total after discount: ${currencyFormatterWithMultiplier(totalAfterDiscount, currency, currencyMultiplier)}`}</p>
          ) : (
              <> </>
            )}
        </div>
      )}
      <div className="text-center pb-5">
        <Card
          actions={[
            <>
              <DollarOutlined className="text-info" /> <br /> Total: <hr />
              {currencyFormatterWithMultiplier(cartTotal, currency, currencyMultiplier)}
            </>,
            <>
              <CheckOutlined className="text-info" /> <br /> Total payable: <hr />
              {currencyFormatter((payable / 100), currency)}
            </>,
          ]}
        />
      </div>
      
      <div className="">
        <div className="">
          <Tabs defaultActiveKey="1" onChange={callback}>
            <TabPane tab={`Card Payment`} key="1">
              <br/>
              <form id="payment-form" className="stripe-form" onSubmit={handleSubmit}>
                <CardElement
                  id="card-element"
                  options={cartStyle}
                  onChange={handleChange}

                />
                  {/* <div className="row">
                  <div className="col-md-6">

                  </div>
                  <div className="col-md-6">
                    <div className="pdl-add-contact-free_container mt-2" style={{
                      float: 'right',
                    }}>
                      <div className="checkbox"><input onChange={onChange} id="contact-less-delivery-check1" name="contact-less-delivery" type="checkbox" aria-checked="true" className="checkbox_input" defaultValue="true" />
                        <label htmlFor="contact-less-delivery-check1" className="checkbox_label ">
                          <div className="checkbox_text checkbox_text--capitalized checkbox_text--direction-column">
                            <div className="checkbox_text--direction-row"><h3>Remember for Future Orders</h3></div>
                          </div>
                          <div className="checkbox_box">
                            <div className="checkbox_icon vector-icon-size--medium"><svg xmlns="http://www.w3.org/2000/svg" aria-label="Checked" viewBox="0 0 32 32" role="presentation" aria-hidden="true" focusable="false" className="vector-icon-stroke--prime">
                              <title lang="en">Checked</title>
                              <desc />
                              <g fill stroke>
                                <path fill="none" strokeWidth={3} d="M28.279 7.467l-16.993 16.993-7.553-7.553" />
                              </g>
                            </svg></div>
                          </div>
                        </label></div>
                    </div>
                  </div>
                </div>
                 */}
                <br/>
                <button
                  className="stripe-button button btn button--prime"
                  disabled={processing || disabled || succeeded}
                >
                  <span id="button-text">
                    {processing ? <div className="spinner" id="spinner"></div> : "Pay"}
                  </span>
                </button>

                <br />

                {loading ? (
                  <>
                    <h4 className="text-danger"><LoadingOutlined /></h4>
                    <h5 className="text-danger">Please don't refresh/close the window before Confirmation Message...</h5>
                  </>
                ) : (
                    <>
                      {error && (
                        <div className="card-error" role="alert">
                          {error}
                        </div>
                      )}
                      <br />
                      {succeeded && (
                        <p className="result-message hidden">
                          Payment Successful. You will get a confirmation link soon {" "}
                          <Link to="/user/history" >See it in your purchase history.</Link>
                        </p>
                      )}
                    </>
                  )}

                <Modal
                  title="Payment Processing"
                  centered
                  visible={loading}
                  closable={false}
                  width={250}
                  zIndex={10000}
                  footer={[

                  ]}
                >
                  <div className="st_helper-text pdl-generic-content_full text-center" >
                    <animated.div
                      style={{
                        opacity: x.interpolate({ range: [0, 5], output: [1, 4] }),
                        transform: x
                          .interpolate({
                            range: [0, 0.25, 0.35, 0.45, 0.55, 0.65, 0.75, 1],
                            output: [1, 0.97, 0.9, 1.1, 0.9, 1.1, 1.03, 1]
                          })
                          .interpolate(x => `scale(${x})`)
                      }}>
                      <CreditCardOutlined style={{ fontSize: 100, width: 100 }} />
                    </animated.div>
                  </div>
                </Modal>
              </form>
            </TabPane>
            {/* <TabPane tab={`UPI Payment`} key="2">
              <form id="payment-form" onSubmit={handeUpi} className="delivery-location_input-container">
                <div id="upi-input" >
                  <h2 htmlFor="vpa" className="delivery-location_text-container text-center">
                    </h2>
                  <div className="delivery-location_wrapper">
                    <div id="upi-element" className="delivery-location_geolocation-container" >
                      <input placeholder="Please Enter UPI Id" type="text" id="vpa" name="vpa" onChange={(e) => { setUpiValie(e.target.value) }} style={{ width: '100%', position: 'relative', fontSize: '20px' }} />
                    </div>
                    <div className="delivery-location_button-container">
                      <button data-secret="pk_live_51Io7B5SAtCMk2QKCQEDQG6fOu2GsdYaOTND3SQjUvUigrVBxOSaHXA6P9INtYX0B62V2dxWnPA9hBPeUJ3U25T1u00bAmU6ces" className="button button--prime button-width--full">
                        {loading ? <LoadingOutlined /> : <>Pay</>}
                      </button>
                    </div>
                  </div>
                </div>
                <div id="upi-message" className="form-row" style={{ display: 'none' }}>
                  <label id="payment-message" />
                </div>
                <div id="error-message" role="alert" />
              </form>
            </TabPane> */}
          </Tabs>

        </div>
      </div>
    </>
  );
};

export default StripeCheckout;
